var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import CrmCardContent from 'components/CrmCardContent.vue';
import { verifyFunilDeVendasCredentials } from '@/clients/crm';
import { NotificationService } from '@/services/NotificationService';
let FunilDeVendasConfigCard = class FunilDeVendasConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.seller = '';
        this.funnel = '';
        this.salesChannel = '';
        this.integrationKey = '';
        this.ocultedCodSellerFunilDeVendas = false;
        this.ocultedKeyCodFunilDeVendas = false;
        this.ocultedCodSalesChannelFunilDeVendas = false;
        this.ocultedTokenFunilDeVendas = false;
        this.credentialsVerified = false;
        this.openModal = false;
        this.openRightDrawer = false;
        this.loading = false;
        this.crmIcon = 'statics/images/logos/funildevendas.png';
        this.companyFields = [
            'Razão Social',
            'CNPJ',
            'Endereço',
            'Setor',
            'Decisores',
            'Outras Informações',
        ];
        this.decisorFields = [
            'Nome',
            'Posição',
            'Nível de decisão',
            'Departamento',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Essencial',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Não foi encontrado restrição de permissão.',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu superior vai em Contatos e então clica em Organizações (ao de Pessoas).',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu superior vai em Contatos e então clica em Pessoas (ao de Empresas) Contatos.',
            },
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('funildevendas');
    }
    async verifyCredentials() {
        this.loading = true;
        try {
            const seller = this.seller;
            const funnel = this.funnel;
            const salesChannel = this.salesChannel;
            const integrationKey = this.integrationKey;
            if (!seller && !funnel && !salesChannel && !integrationKey) {
                NotificationService.error('Error', 'Preencha todos os campos');
                this.loading = false;
                return;
            }
            await verifyFunilDeVendasCredentials({
                seller,
                funnel,
                salesChannel,
                integrationKey,
            });
            this.credentialsVerified = true;
            this.ocultedTokenFunilDeVendas = true;
            this.ocultedCodSellerFunilDeVendas = true;
            this.ocultedCodSalesChannelFunilDeVendas = true;
            this.ocultedKeyCodFunilDeVendas = true;
            NotificationService.success('Sucesso', 'Suas credenciais foram salvas com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'As credenciais selecionadas estão inválidas');
        }
        this.loading = false;
    }
    changeToken() {
        this.integrationKey = '';
        this.seller = '';
        this.salesChannel = '';
        this.funnel = '';
        this.credentialsVerified = false;
    }
};
FunilDeVendasConfigCard = __decorate([
    Component({
        name: 'FunilDeVendasConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], FunilDeVendasConfigCard);
export default FunilDeVendasConfigCard;
